import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "../../types/commonElements";
import {
  appointmentPurposeOptions,
  consultationOptions,
  patientSourceOptions,
  selectSexOptions,
} from "../../config/constants/options";
import dayjs from "dayjs";
import { FormData, UserState } from "../../types/appointmentTypes";

const formData: FormData = {
  name: "",
  appointmentType: 1,
  phoneNumber: "",
  consultation: "",
  sex: "",
  age: "",
  email: "",
  birthDate: null,
  appointmentDate: dayjs(),
  timeSlot: null,
  doctor: "",
  appointmentPurpose: "",
  patientSource: "",
  allSlots: [],
  selectedSlot: "",
  uuid: "",
  branchId: "",
  patientType: "New",
  appointmentTime: "",
  procedureName: "",
  session: "",
  sentByDoctor: "",
  isFirstTimeOpen: false,
  patientId: "",
  appointmentId: "",
  lastConsultationDate:"",
  lastProcedureDate:"",
};

const initialState: UserState = {
  formData: formData,
  errors: {}, 
  selectOptions: {
    phoneNumber: [],
    consultation: consultationOptions,
    doctor: [],
    appointmentPurpose: appointmentPurposeOptions,
    patientSource: patientSourceOptions,
    sex: selectSexOptions,
    procedureName: [],
    session: [],
    sentByDoctor: [],
  },
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = {...state?.selectOptions,...action?.payload};
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = { ...formData };
      state.errors = {};
      state.selectOptions = initialState.selectOptions;
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
